var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mm", class: { active: _vm.ready } }, [
    _c("h1", { staticClass: "landing-h mod-mm" }, [
      _vm._v("We\n    "),
      _c("div", { staticClass: "mm-flip" }, [
        _c(
          "span",
          {
            class: {
              "flip-in": _vm.state === "video",
              "flip-out": _vm.state === "web"
            }
          },
          [_vm._v("make videos.")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            class: {
              "flip-in": _vm.state === "web",
              "flip-out": _vm.state === "video"
            }
          },
          [_vm._v("build websites.")]
        )
      ])
    ]),
    _vm._v(" "),
    _c("h1", { staticClass: "landing-h mod-mm" }, [
      _vm._v("Really good\n    "),
      _c("div", { staticClass: "mm-flip second" }, [
        _c(
          "span",
          {
            class: {
              "flip-in": _vm.state === "video",
              "flip-out": _vm.state === "web"
            }
          },
          [_vm._v("videos.")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            class: {
              "flip-in": _vm.state === "web",
              "flip-out": _vm.state === "video"
            }
          },
          [_vm._v("websites.")]
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mm-cta" }, [
      _c(
        "a",
        { staticClass: "button mm-cta-video", attrs: { href: "#start" } },
        [_vm._v("I have a video project")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "button mm-cta-web",
          attrs: { href: "https://web.squaredaisy.com#start" }
        },
        [_vm._v("I have a web project")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }